<script setup>
import {Theme} from "@/composables/theming";
import {defineProps, defineEmits} from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter();

defineEmits(['updatePlanning', 'deletePlanning', 'showQrcode'])

const props = defineProps({
  planning: { type: Object, required: true },
  eventId: { type: String, required: true }
})

function showPlanningDetail(id) {
  router.push({name: 'events-planning-view', params: {id: props.eventId, planning: id} })
}
</script>

<template>
  <div class="d-flex align-items-center border border-gray-300 rounded min-w-750px px-7 py-5 mb-5">

    <div class="min-w-175px pe-2 border-right-1 border-gray-300">
      <span>{{ planning.start_time }} </span>
      <span v-if="planning.end_time">- {{ planning.end_time }}</span> :
    </div>
    <div class="pe-2 me-auto">
      <h2 v-html="planning.title"></h2>
      <span v-html="planning.description"></span>
    </div>

    <div class="d-flex align-items-center flex-shrink-0 ms-2">
      
      <a v-if="planning.type === 'ATELIER'"
         @click.prevent="$emit('showQrcode', planning.joinLink)"
         class="btn btn-sm btn-clean btn-icon ms-3"
         :title="$t('events.planning.qrcode')">
        <i class="fas fa-qrcode fs-2" :style="{ color: Theme.gray }"></i>
      </a>

      <a v-if="planning.type === 'ATELIER'"
         @click.prevent="showPlanningDetail(planning.id)"
         class="btn btn-sm btn-clean btn-icon ms-3"
         :title="$t('button.show')">
        <i class="fas fa-eye fs-2" :style="{ color: Theme.gray }"></i>
      </a>

      <a @click.prevent="$emit('updatePlanning', planning.id)"
         class="btn btn-sm btn-clean btn-icon ms-3"
         :title="$t('button.edit')">
        <i class="fas fa-edit fs-2" :style="{ color: Theme.gray }"></i>
      </a>

      <a @click.prevent="$emit('deletePlanning', planning.id)"
         class="btn btn-sm btn-clean btn-icon ms-3"
         :title="$t('button.delete')">
        <i class="fas fa-trash fs-2" :style="{ color: Theme.gray }"></i>
      </a>
      
    </div>

  </div>
</template>

<style scoped>

</style>